import { useParams } from '@tanstack/react-router';
import { EventHandler } from '_/types/common.types';
import { SyntheticEvent, useCallback } from 'react';

const useFlowOpen = (target = '_blank'): EventHandler<SyntheticEvent> => {
  const params = useParams({ strict: false }) as Partial<Record<string, string>>;
  const flowSlug = params.flowSlug || '';
  const orgSlug = params.orgSlug || '';
  const projectSlug = params.projectSlug || '';

  return useCallback(
    (e: SyntheticEvent) => {
      e.stopPropagation();
      const url = `${window.origin}/orgs/${orgSlug}/projects/${projectSlug}/flows/${flowSlug}`;
      window.open(url, target);
    },
    [flowSlug, orgSlug, projectSlug, target],
  );
};

export default useFlowOpen;
